<template>
  <!-- 列表申请 -->
  <div class="home">
    <div class="search">
      <div class="title">项目列表</div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="项目名称：">
          <el-input
            style="width: 180px"
            v-model="formInline.projectName"
            placeholder="项目名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="标段名称：">
          <el-input
            style="width: 180px"
            v-model="formInline.bidName"
            placeholder="标段名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="招标人：">
          <el-input
            style="width: 180px"
            v-model="formInline.profitsPerson"
            placeholder="招标人"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="所属区域">
          <el-select style="width:180px;" v-model="formInline.payment" placeholder="请选择">
            <el-option label="已支付" value="0"></el-option>
            <el-option label="待支付" value="1"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="开标日期">
          <el-date-picker
            style="width: 180px"
            v-model="formInline.bidTime"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="query">查询</el-button>
          <el-button type="info" @click="Reset">重置</el-button>
        </el-form-item>
      </el-form>
      <!-- <div style="margin-bottom: 10px; text-align: right">
        <span style="margin-right: 10px">未找到项目信息，上传材料进行</span>
        <el-button type="primary" @click="selfHelp">自助申请保函</el-button>
      </div> -->
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        :height="tableHeight"
      >
        <el-table-column label="序号" align="center" type="index" width="50">
        </el-table-column>
        <el-table-column prop="projectName" label="项目名称" align="center">
        </el-table-column>
        <el-table-column prop="bidName" label="标段名称" align="center">
        </el-table-column>
        <el-table-column prop="profitsPerson" label="招标人" align="center">
        </el-table-column>
        <el-table-column prop="guaMoney" align="center" label="保证金金额">
        </el-table-column>
        <!-- <el-table-column prop="city" align="center" label="所属地区">
      </el-table-column> -->
        <el-table-column prop="bidBeginDate" align="center" label="开标日期">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="apply(scope.row)"
              >立即申请</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="this.formInline.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="this.formInline.pageNum"
        layout="total, sizes, prev, pager, next, jumper"
        :total="this.total"
      ></el-pagination>
    </div>
    <el-dialog
      class="tips"
      title="提示"
      :visible.sync="centerDialogVisible"
      width="18%"
      center
      :show-close="false"
    >
      <div style="text-align: center">
        <span style="font-size: 18px">请先进行企业信息认证</span>
      </div>
      <div style="text-align: center; margin-top: 40px">
        <el-button
          style="background: #7f7f7f; border-radius: 0; border: 0; color: #fff"
          @click="guarantee"
          >关 闭</el-button
        >
        <el-button
          style="background: #0065b3; border-radius: 0; border: 0; color: #fff"
          @click="guarantee"
          >立即补充</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { getManageList } from "../apis/project/index";
export default {
  data() {
    return {
      tableHeight: null,
      centerDialogVisible: false,
      total: null,
      formInline: {
        bidTime: "",
        profitsPerson: "",
        bidName: "",
        projectName: "",
        pageNum: 10,
        page: 1,
      },
      tableData: [],
    };
  },
  methods: {
    query() {
      this.formInline.page = 1;
      this.getList();
    },
    getList() {
      getManageList(this.formInline).then((res) => {
        this.tableData = res.data.data.data;
        this.total = res.data.data.total;
      });
    },
    heightTab() {
      this.tableHeight = document.documentElement.clientHeight - 456;
    },
    Reset() {
      this.formInline.page = 1;
      this.formInline.projectName = null;
      this.formInline.bidTime = null;
      this.formInline.profitsPerson = null;
      this.formInline.bidName = null;
      this.getList();
    },
    selfHelp() {
      this.$router.push("/selfHelp");
    },
    apply(e) {
      this.axios({
        method: "POST",
        url: "/AttestationController/checkComInfo",
        data: {
          userName: window.sessionStorage.getItem("username"),
          phoneNum: window.sessionStorage.getItem("phoneNum"),
          from: "33",
        },
      }).then((res) => {
        if (res.data.status > 0) {
          window.sessionStorage.setItem("manageId", e.id);
          this.$router.push("/agreement");
          // this.centerDialogVisible = true;
        } else {
          this.centerDialogVisible = true;
        }
      });
    },
    guarantee() {
      this.centerDialogVisible = false;
      this.$router.push("/enterprise");
    },
    handleSizeChange(val) {
      this.formInline.page = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.formInline.pageNum = val;
      this.getList();
    },
  },
  mounted() {
    this.heightTab();
    window.addEventListener("resize", this.heightTab, false);
    this.getList();
  },
};
</script>
<style scoped>
.home {
  height: 100%;
  margin-top: 15px;
}
.search {
  padding: 15px 35px;
}
.table {
  margin-top: 15px;
}
.tips >>> .el-dialog__header {
  background: #0065b3;
}
.tips >>> .el-dialog__title {
  color: #fff;
  font-weight: bold;
}
.tips >>> .el-dialog__body {
  background: #f2f2f2;
}
</style>
